import categories from './categories/main'
import childOrganisations from './childOrganisations/main'
import forms from './forms/main'
import fundingPrograms from './fundingPrograms/main'
import general from './general/main'
import mailTemplates from './mailTemplates/main'
import organisationUsers from './organisationUsers/main'
import organisations from './organisations/main'
import processes from './processes/main'
import roles from './roles/main'
import statusNotifications from "./statusNotifications/main"
import statuses from './statuses/main'
import userOrganisations from './userOrganisations/main'
import users from './users/main'
import yearInterviews from './yearInterviews/main'
import years from './years/main'

export default {
    selected: 'Ausgewählt',

    categories,
    childOrganisations,
    forms,
    fundingPrograms,
    general,
    mailTemplates,
    organisationUsers,
    organisations,
    processes,
    roles,
    statusNotifications,
    statuses,
    userOrganisations,
    users,
    yearInterviews,
    years,
}